export default __webpack_public_path__ + "static/media/BlueScrum.8c7f5022.png";